// Screen `form-builder` (public form) — design/screens/FormBuilder.dc.html — owner: S5.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { PublicFormPage } from '../../../features/forms/PublicFormPage';

export const Route = createFileRoute('/_public/f/$slug')({
  validateSearch: z.object({ preview: z.coerce.string().max(5).optional() }),
  component: PublicFormRoute,
});

function PublicFormRoute() {
  const { slug } = Route.useParams();
  const { preview } = Route.useSearch();
  return <PublicFormPage key={slug} slug={slug} preview={preview === '1' || preview === 'true'} />;
}
